import { Routes } from '@angular/router';
import {Layout} from './layout/layout/layout';
import {AuthorizeGuard} from './autorization/auth.guard';
import {Home} from './pages/home/home';
import {ResultPage} from './pages/testing/components/testing-page/components/result-page/result-page/result-page';
import {Testing} from './pages/testing/components/testing';
import {TestingPage} from './pages/testing/components/testing-page/testing-page';
import {Anketa} from './pages/anketa/anketa';
import {Notfound} from '../assets/shared/notfound/notfound';
import {Lections} from './pages/cources/lections/lections';
import {TestGuard} from './core/test-guard/test-guard-guard';


export const routes: Routes = [

  { path: '', redirectTo: 'not-found', pathMatch: 'full'},

  { path: 'not-found', component: Layout, children: [ { path: '', component: Notfound } ] },

  { path: 'error-course', component: Layout, children: [ { path: '', component: Notfound } ] },

  {
    path: ':coursesId',
    component: Layout,
    canActivate: [AuthorizeGuard],
    children: [
      { path: '', component: Home },
      { path: 'testing/:type/:module', component: Testing, canActivate: [TestGuard] },
      { path: 'test/:type/:module', component: TestingPage, canActivate: [TestGuard] },
      { path: 'test/result', component: ResultPage },
      { path: 'anketa', component: Anketa },
      { path: 'lesson/:id', component: Lections },
      { path: '**', redirectTo: 'not-found'}
    ]
  },
  { path: '**', redirectTo: 'not-found' }
];
